<!--
 * @Author: WeiZisen
 * @Date: 2021-03-15 11:13:04
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-05-26 09:51:01
 * @Description: 请输入一段描述
 * @FilePath: \Vue_RebarProcess\src\common\components\VabMenu\components\MenuItem.vue
-->
<template>
  <el-menu-item :index="itemOrMenu.path" @click="handleLink">
    <vab-remix-icon
      v-if="itemOrMenu.meta && itemOrMenu.meta.remixIcon"
      :is-custom-svg="itemOrMenu.meta.isCustomSvgIcon"
      :icon="itemOrMenu.meta.remixIcon"
      class="vab-remix-icon"
    />
    {{ translateTitle(itemOrMenu.meta.title) }}
    <el-tag v-if="itemOrMenu.meta && itemOrMenu.meta.badge" effect="dark" type="danger">
      {{ itemOrMenu.meta.badge }}
    </el-tag>
  </el-menu-item>
</template>

<script>
  import { translateTitle } from '@/utils/i18n'
  import { isExternal } from '@/utils/validate'

  export default {
    name: 'MenuItem',
    props: {
      itemOrMenu: {
        type: Object,
        default() {
          return null
        },
      },
    },
    methods: {
      translateTitle,
      handleLink() {
        const routePath = this.itemOrMenu.path

        const target = this.itemOrMenu.meta.target
        if (target === '_blank') {
          if (isExternal(routePath)) window.open(routePath)
          else if (this.$route.path !== routePath) window.open(routePath.href)
        } else {
          if (isExternal(routePath)) window.location.href = routePath
          else if (this.$route.path !== routePath) this.$router.push({ path: routePath, query: { author: this.itemOrMenu.meta.author } })
        }
      },
    },
  }
</script>
